/**
 * FinPip "F" logo mark as an inline SVG that inherits the current text color
 * (fill="currentColor"), so it stays visible in BOTH the light and dark journal
 * themes — pair it with a `text-parchment` (or similar) className.
 */
export default function FinPipMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 400 400" className={className} role="img" aria-label="FinPip" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M79.4 77 L79.4 94 183.1 94 L286.8 94 286.8 159.6 L286.8 225.2 231.7 225.2 L176.6 225.2 176.6 265.6 L176.6 306 145 306 L113.4 306 113.4 246.4 L113.4 186.8 176.3 186.8 L239.2 186.8 239.2 169.8 L239.2 152.8 159.3 152.8 L79.4 152.8 79.4 246.4 L79.4 340 145 340 L210.6 340 210.6 299.6 L210.6 259.2 265.7 259.2 L320.8 259.2 320.8 159.6 L320.8 60 200.1 60 L79.4 60 79.4 77 Z"
      />
    </svg>
  );
}
